import Vue from "vue";
import VueCookies from "vue-cookies";
import { ValidationProvider, ValidationObserver } from "vee-validate";

import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import "./plugins/validate";
import { i18n } from "./plugins/i18n";

Vue.component("ValidationProvider", ValidationProvider);
Vue.component("ValidationObserver", ValidationObserver);

Vue.use(VueCookies);

Vue.config.productionTip = false;

new Vue({
  vuetify,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
